import axios from "axios";
import { 
    GET_LEAD_FORM_FAIL, GET_LEAD_FORM_SUCCESS, GET_LEAD_FORM_REQUEST, 
    LEAD_FORM_SUBMIT_FAIL, LEAD_FORM_SUBMIT_REQUEST, LEAD_FORM_SUBMIT_SUCCESS, 
    PUBLISH_REQUEST, PUBLISH_SUCCESS,PUBLISH_FAIL,
    GET_PRIVACY_POLICY_REQUEST, GET_PRIVACY_POLICY_SUCCESS, GET_PRIVACY_POLICY_FAIL,
    GET_COOKIE_POLICY_REQUEST, GET_COOKIE_POLICY_SUCCESS, GET_COOKIE_POLICY_FAIL,
    GET_GROUP_LANGUAGES_REQUEST, GET_GROUP_LANGUAGES_SUCCESS, GET_GROUP_LANGUAGES_FAIL
} from "../constant";
import { clearAllFields } from "./surveyFieldDataAction";

export const getLeadFormData = (data, navigate) => {
    return async (dispatch) => {
        dispatch({ type: GET_LEAD_FORM_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/getLeadForm`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                localStorage.setItem("customer_token", res?.data?.token)
                dispatch({ type: GET_LEAD_FORM_SUCCESS, payload: res?.data?.data });
                if (res?.data?.data?.length === 0) {
                    navigate('/')
                }
            })
            .catch(err => {
                console.error("GET FORM DATA FAIL", err)
                dispatch({ type: GET_LEAD_FORM_FAIL });
            })
    }
}

export const submitLeadFormData = (data, navigate) => {
    return async (dispatch) => {
        dispatch({ type: LEAD_FORM_SUBMIT_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/submitLead`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        return await axios(options)
            .then(res => {
                localStorage.setItem("customer_token", res?.data?.token)
                dispatch({ type: LEAD_FORM_SUBMIT_SUCCESS, payload: res?.data?.ss_id });
                dispatch(clearAllFields())
                navigate(`/qna/${data.survey_id}/${res?.data?.ss_id}`);
                return res?.data;
            })
            .catch(err => {
                console.error("FORM DATA FAIL", err)
                dispatch({ type: LEAD_FORM_SUBMIT_FAIL });
            })
    }
}

export const checkPublish = (data, navigate) => {
    return async (dispatch) => {
        dispatch({ type: PUBLISH_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/checkPublish`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                localStorage.setItem("customer_token", res?.data?.token)
                dispatch({ type: PUBLISH_SUCCESS, payload: res?.data?.data });
                if (res?.data?.data?.length === 0) {
                    navigate('/')
                }
            })
            .catch(err => {
                console.error("PUBLISH FAIL", err)
                dispatch({ type: PUBLISH_FAIL });
            })
    }
}

export const getPrivacyPolicy = (survey_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_PRIVACY_POLICY_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'GET',
            url: `${process.env.REACT_APP_API_URL}/survey/getPrivacyPolicy/${survey_id}`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };
        await axios(options)
            .then(res => {
                dispatch({ type: GET_PRIVACY_POLICY_SUCCESS, payload: res?.data?.data });
            })
            .catch(err => {
                console.error("GET PRIVACY POLICY FAIL", err)
                dispatch({ type: GET_PRIVACY_POLICY_FAIL });
            })
    }
}

export const getCookiePolicy = (survey_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_COOKIE_POLICY_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'GET',
            url: `${process.env.REACT_APP_API_URL}/frnt/cookie-policy/${survey_id}`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };
        await axios(options)
            .then(res => {
                dispatch({ type: GET_COOKIE_POLICY_SUCCESS, payload: res?.data?.data });
            })
            .catch(err => {
                console.error("GET COOKIE POLICY FAIL", err)
                dispatch({ type: GET_COOKIE_POLICY_FAIL });
            })
    }
}

export const getGroupLanguages = (group_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_GROUP_LANGUAGES_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'GET',
            url: `${process.env.REACT_APP_API_URL}/survey/getGroupLanguagesPublic?group_id=${group_id}`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };
        await axios(options)
            .then(res => {
                dispatch({ type: GET_GROUP_LANGUAGES_SUCCESS, payload: res?.data?.data });
            })
            .catch(err => {
                console.error("GET GROUP LANGUAGES FAIL", err)
                dispatch({ type: GET_GROUP_LANGUAGES_FAIL });
            })
    }
}